import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import CartAddOns from '@/plugins/graphql/queries/v2/cart-add-ons.gql';
import CartAddOnDelete from '@/plugins/graphql/mutations/v2/cart-add-on-delete.gql';
import { Getter, Mutation } from 'vuex-class';
import { successfulDestroy } from '@/helpers/mixins/LocalizationHelper';
import { CartAddOnModel } from '@/helpers/entities/models/CartAddOnModel';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import Paginator from '@/components/v2/Paginator.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartAddOnManager = class CartAddOnManager extends mixins(FormMixin, PaginatorMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.cartAddOns = [];
        this.selectedCartAddOnUuid = null;
    }
    toggleConfirmation(uuid) {
        this.selectedCartAddOnUuid = uuid;
        this.showConfirmationDialog();
    }
    goToCartAddOnDetailsPage(uuid) {
        this.addOnAction('START EDIT');
        this.$router.push({
            name: 'ecommerce-add-ons-edit',
            params: {
                uuid,
            },
        });
    }
    async uponConfirm() {
        this.requestOnFlight();
        await this.delete()
            .then(() => {
            const msg = successfulDestroy('Cart Add On');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    async delete() {
        const { appUuid } = this;
        if (!this.selectedCartAddOnUuid) {
            return;
        }
        await this.$apollo.mutate({
            mutation: CartAddOnDelete,
            variables: {
                input: {
                    cartAddOnUuid: this.selectedCartAddOnUuid,
                },
            },
        });
        const refetchVariables = this.cartAddOns.length === 1 ? { appUuid, first: 10, after: null } : undefined;
        this.$apollo.queries.cartAddOns.refetch(refetchVariables);
    }
};
__decorate([
    Getter('appUuid')
], CartAddOnManager.prototype, "appUuid", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], CartAddOnManager.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], CartAddOnManager.prototype, "hideConfirmationDialog", void 0);
CartAddOnManager = __decorate([
    Component({
        apollo: {
            cartAddOns: {
                query: CartAddOns,
                variables() {
                    return {
                        appUuid: this.appUuid,
                        first: this.perPage,
                        after: this.startCursor,
                    };
                },
                fetchPolicy: 'network-only',
                update({ fetchAllCartAddOn }) {
                    const { edges, pageInfo, totalCount } = fetchAllCartAddOn;
                    const cartAddOnNodes = (cartAddOn) => {
                        return new CartAddOnModel(cartAddOn.node);
                    };
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map(cartAddOnNodes);
                },
            },
        },
        components: {
            ConfirmationDialog,
            BaseOverlayLoader,
            Paginator,
        },
    })
], CartAddOnManager);
export default CartAddOnManager;
